// Logger utility for Vercel environment
const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  log: (message: string, data?: any) => {
    if (isProduction) {
      // In production, only log non-sensitive information
      const sanitizedData = data ? sanitizeData(data) : undefined;
      console.warn(`[LOG] ${message}`, sanitizedData);
    } else {
      console.log(message, data);
    }
  },
  
  error: (message: string, error?: any) => {
    if (isProduction) {
      // In production, sanitize error details
      console.error(`[ERROR] ${message}`, sanitizeError(error));
    } else {
      console.error(message, error);
    }
  },

  info: (message: string, data?: any) => {
    if (isProduction) {
      // In production, only log non-sensitive information
      const sanitizedData = data ? sanitizeData(data) : undefined;
      console.info(`[INFO] ${message}`, sanitizedData);
    } else {
      console.info(message, data);
    }
  }
};

// Sanitize sensitive data before logging
const sanitizeData = (data: any): any => {
  if (!data) return data;
  
  // If data is an object, create a new object with sanitized values
  if (typeof data === 'object') {
    const sanitized: any = {};
    for (const [key, value] of Object.entries(data)) {
      // Skip sensitive keys in production logs
      if (isProduction && isSensitiveKey(key)) {
        sanitized[key] = '[REDACTED]';
      } else if (typeof value === 'object') {
        sanitized[key] = sanitizeData(value);
      } else {
        sanitized[key] = value;
      }
    }
    return sanitized;
  }
  
  return data;
};

// Sanitize error objects
const sanitizeError = (error: any): any => {
  if (!error) return error;
  
  return {
    message: error.message,
    code: error.code,
    type: error.type,
    // Exclude stack traces and sensitive details in production
    ...(isProduction ? {} : { stack: error.stack })
  };
};

// Check if a key might contain sensitive information
const isSensitiveKey = (key: string): boolean => {
  const sensitivePatterns = [
    /token/i,
    /key/i,
    /secret/i,
    /password/i,
    /auth/i,
    /credential/i
  ];
  
  return sensitivePatterns.some(pattern => pattern.test(key));
}; 